import { useLocation, useRoutes } from 'react-router-dom';
import './App.scss';
import routes from './routes';
import { useDispatch, useSelector } from 'react-redux';
import { getIsLogged, getPrivacyPolicyRead, getUser } from 'features/auth';
import { useEffect } from 'react';
import { locationListener } from 'utils/locationListener';
import { ToastProvider, Toaster } from 'components/Toaster';

function App() {
    const isLogged = useSelector(getIsLogged);
    const isPrivacyPolicyRead = useSelector(getPrivacyPolicyRead);
    const user = useSelector(getUser);
    const routing = useRoutes(routes(isLogged, isPrivacyPolicyRead, user?.role));

    let location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        locationListener(location, dispatch);
    }, [location, dispatch]);

    return (
        <ToastProvider defaultDuration={3000}>
            <div className="App">
                <>{routing}</>
                <Toaster position="bottom-right" />
            </div>
        </ToastProvider>
    );
}

export default App;
